import isComplete from './is-complete'
import _ from 'lodash'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO } = DataType

/**
 * Returns true if the given filter will not affect the query results (noop),
 * and can thus be ignored
 */
function isNoop (filter, dataset) {
	let field = dataset.getUnderlyingField(filter.fieldId)
	if (_.isNil(field) || (field.dataType === YES_NO &&
		filter.operator === 'is-any' && _.isEmpty(filter.values))) {
		// yes-no's 'is-any' doesn't need any extra info, so isComplete() will
		// return true. But since 'is-any' with no values is the default state
		// for a yes-no filter widget and it doesn't affect the query results,
		// it's a noop
		return true
	}

	// #26925 #27019 ignore incomplete filters
	return !isComplete(filter, field)
}

export default isNoop

isNoop.__filename__ = 'datasets/filters/is-noop.js'
